/* jshint esversion: 11 */

// Browser-History und Navigationstiefe der App (navigationDepth in Main.elm).
//
// Jeder Eintrag der App trägt im History-State seine Tiefe. Geht die App tiefer,
// kommt ein Eintrag hinzu; geht sie über eigene Knöpfe zurück, geht die History um
// dieselbe Zahl Einträge zurück. Zurück und Vor im Browser meldet die Tiefe des
// erreichten Eintrags an Elm, das dorthin zurückgeht oder die History korrigiert.

export function connectHistory(app) {
    let depth = 0;
    let wanted = 0;
    let traversing = false;

    history.replaceState({ziegeDepth: 0}, "");

    // Solange ein history.go läuft, ist die Position in der History unbekannt; der
    // Abgleich folgt nach dessen popstate.
    function sync() {
        if (traversing) {
            return;
        }
        if (wanted > depth) {
            history.pushState({ziegeDepth: wanted}, "");
            depth = wanted;
        } else if (wanted < depth) {
            traversing = true;
            history.go(wanted - depth);
        }
    }

    app.ports.navigateTo.subscribe((target) => {
        wanted = target;
        sync();
    });

    window.addEventListener("popstate", (event) => {
        depth = event.state?.ziegeDepth ?? 0;
        if (traversing) {
            traversing = false;
            sync();
            return;
        }
        wanted = depth;
        app.ports.browserNavigated.send(depth);
    });
}
